<template>
  <div>
    <div v-if="sum_time > 0" class="sum_time">
      <p>SUM TIME: <b>{{ time_helper.convertDecimalHoursToTime(sum_time) }}</b></p>
    </div>
    <admin-recruiter-chooser></admin-recruiter-chooser>
    <datatable
      title="Efforts"
      @last_week="setDate('lastWeek')"
      @last_month="setDate('lastMonth')"
      @yesterday="setDate('yesterday')"
      @today="setDate('today')"
      @info="showStatInfo"
      :fields="fields"
      :response="data"
      :filters="filters"
      :show_delete="false"
      :show_edit="false"
      :operations="operations"
      :unique_buttons="unique_buttons"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import DataTable from '@/components/DataTable.vue'
import AdminRecruiterChooser from '@/components/admin/AdminRecruiterChooser'
export default {
  name: 'admin-efforts',
  data () {
    let time_helper = new TimeHelper()
    return {
      time_helper,
      fields: [
        {
          name: 'resource',
          component_data_path: 'resource',
          component: 'LinkEntity'
        },
        {
          name: 'time',
          value: 'time.display_text'
        }
      ],
      filters: [
        {
          type: 'date',
          designator: 'date_from'
        },
        {
          type: 'date',
          designator: 'date_to'
        }
      ],
      data: [],
      unique_buttons: [
        {
          name: 'last_month',
          display_text: 'Last Month',
          css_classes: {
            'is-info': () => this.$route.query.date_from == time_helper.getLastMonth().atMidnight().toUTCString()
          }
        },
        {
          name: 'last_week',
          display_text: 'Last Week',
          css_classes: {
            'is-info': () => this.$route.query.date_from == time_helper.getLastWeek().atMidnight().toUTCString()
          }
        },
        {
          name: 'yesterday',
          display_text: 'Yesterday',
          css_classes: {
            'is-info': () => this.$route.query.date_from == time_helper.getYesterday().atMidnight().toUTCString()
          }
        },
        {
          name: 'today',
          display_text: 'Today',
          css_classes: {
            'is-info': () => this.$route.query.date_from == time_helper.getToday().atMidnight().toUTCString()
          }
        }
      ],
      operations: [{ name: 'info', icon: '/info.svg' }],
      efforts: {},
      maximum_minutes: 20,
      sum_time: 0
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      let dates_filter = this.hasDateFilters() ? { date_from: this.$route.query.date_from, date_to: this.$route.query.date_to } : {}
      this.$network_utils.getStats({
        owner: this.$route.query.recruiter || this.$utils.getOwner().name,
        created_by: 'Admin',
        ...dates_filter
      }).then(response => {
        this.mapEfforts(response)
        this.createTableData()
      })
    },
    hasDateFilters () {
      return this.$route.query.date_from != undefined && this.$route.query.date_to != undefined
    },
    mapEfforts (stats) {
      for (let i = 0; i < stats.length; i++) {
        let start_stat = stats[i]
        if (start_stat.resource_type == 'Admin' || start_stat.resource_id == undefined) {
          continue
        }
        let end_stat = stats[i + 1]
        if (end_stat == undefined || end_stat.resource_id == undefined) {
          continue
        }
        let time_difference = this.time_helper.getTimeDifference(start_stat.created_at, end_stat.created_at)
        let minutes = time_difference.asMinutes()
        let increment_time = minutes > this.maximum_minutes ? (this.maximum_minutes / 60) : time_difference.asHours()
        this.sum_time += increment_time
        this.getResources(start_stat).forEach(resource => {
          if (resource.resource_type == undefined) {
            resource.resource_type = 'Position'
          }
          this.incrementResourceEffort(resource, start_stat, increment_time)
        })
      }
    },
    getResources (stat) {
      if (stat.resource_type == 'Applicant') {
        return [stat.resources.applicant]
      }
      if (stat.resource_type == 'Position') {
        return [stat.resources.position, stat.resources.company]
      }
      if (stat.resource_type == 'Company') {
        return [stat.resources.company]
      }
      if (stat.resource_type == 'Offer') {
        return [stat.resources.applicant, stat.resources.position, stat.resources.company]
      }
      return []
    },
    createTableData () {
      if (Object.keys(this.efforts).length == 0) {
        this.data = []
        return
      }
      for (let effort_key in this.efforts) {
        let effort = this.efforts[effort_key]
        let time = this.getEffortSumTime(effort)
        this.data.push({
          resource: effort.resource,
          time: {
            value: time,
            display_text: this.time_helper.convertDecimalHoursToTime(time)
          },
          stats: effort.stats
        })
      }
      this.data.sort((a, b) => {
        return b.time.value - a.time.value
      })
    },
    incrementResourceEffort (resource, stat, time) {
      let resource_id = this.getResourceId(resource)
      let effort_key = resource.resource_type + '-' + resource_id
      if (this.efforts[effort_key] == undefined) {
        this.efforts[effort_key] = { resource, stats: [] }
      }
      stat.effort_time = Math.abs(time)
      this.efforts[effort_key].stats.push(stat)
    },
    getResourceId (stat) {
      let resource_type = stat.resource_type
      if (resource_type == 'Applicant') {
        return stat.resource_id
      }
      if (resource_type == 'Company') {
        return stat.resource_id
      }
      return stat.id
    },
    getRecruitersOptions () {
      return this.$settings.get({ path: 'owners' }).map(owner => {
        return { text: owner.name, value: owner.name }
      })
    },
    getEffortSumTime (effort) {
      let time = 0
      effort.stats.forEach(stat => {
        time += stat.effort_time
      })
      return time
    },
    showStatInfo (effort) {
      let sum_time = this.time_helper.convertDecimalHoursToTime(this.getEffortSumTime(effort))
      this.create({
        designator: 'resource-effort-modal',
        component_name: 'ResourceEffort',
        effort,
        modal_title: `Resource Efforts - SUM TIME: ${sum_time}`
      })
    },
    setDate (date) {
      let dates = this[date]()
      let query = { ...this.$route.query }
      query.date_from = dates.date_from.atMidnight().toUTCString()
      query.date_to = dates.date_to.atMidnight().toUTCString()
      this.$router.push({ name: this.$route.name, query })
    },
    lastWeek () {
      return { date_from: this.time_helper.getLastWeek(), date_to: this.time_helper.getToday() }
    },
    lastMonth () {
      return { date_from: this.time_helper.getLastMonth(), date_to: this.time_helper.getToday() }
    },
    yesterday () {
      return { date_from: this.time_helper.getYesterday(), date_to: this.time_helper.getToday() }
    },
    today () {
      return { date_from: this.time_helper.getToday(), date_to: this.time_helper.getTomorrow() }
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable,
    AdminRecruiterChooser
  }
}
</script>
<style scoped>
  .sum_time{
    margin-left: 30px;
  }
  .sum_time p {
    margin-top: 0;
  }
</style>
